export const logout = {
  title: 'Por favor, aguarde uns segundos.',
  description: 'Estamos finalizando a sua sessão.',
};
